export default __webpack_public_path__ + "static/media/department4.f373702b.png";